module.exports = __webpack_public_path__ + "img/1alB-sh-shnej.dee09e95.jpg";